import React, { useState, useEffect } from 'react';
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

function SuperUserRequestForm({username, locationName, onClose}) {

    const [requestTitle, setRequestTitle] = useState("");
    const [requestReason, setRequestReason] = useState("");

    const {language} = useLanguage();
    
        const translations = {
            en: {
                sendRequest: "Delete Location",
                SuperUserRequest: `Request to become a superuser of ${locationName}`,
                cancel: "Cancel",
                title: "Title",
                requestReason: "Please provide a reason for this request.",
                   
            },
    
            gd: {
                sendRequest: "Dubh às an t-àite",
                SuperUserRequest: `Iarr a bhith nad àrd-chleachdair de ${locationName}`,
                cancel: "Dubh às",
                title: "Tiotal",
                requestReason: "Please provide a reason for this request.",
            },
        };

    const handleSubmit = async () => {
        
        const response = await fetch(`${BASE_URL}/api/save_superuser_request/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "username": username,
                "location_name": locationName,
                "request_title": requestTitle,
                "request_content": requestReason}),

        }
        
        )
        onClose();
    };

    return(
        <div>
            <h1>{translations[language].SuperUserRequest}</h1>
            <form onSubmit={handleSubmit}>

                <input
                    required
                    type="text"
                    id="title"
                    placeholder={translations[language].title}
                    value={requestTitle}
                    className="user-report-input-box-long"
                    onChange={(e) => setRequestTitle(e.target.value)}
                />

                <textarea
                    required
                    value={requestReason}
                    onChange={(e) => setRequestReason(e.target.value)}
                    placeholder={translations[language].requestReason}
                    rows="4"
                    cols="50"
                ></textarea>
                <br />
            
                <button type="submit">{translations[language].sendRequest}</button>
                <button onClick={onClose}>{translations[language].cancel}</button>
            </form>
        </div>
    )
}

export default SuperUserRequestForm;